import { useMutation } from '@tanstack/react-query';
import { invalidateLibraryManagedProductGroupFeaturedPages } from './useLibraryManagedProductGroupsFeaturePages';
import { saveLibraryManagedProductGroupProperties } from './apiSaveLibraryManagedProductGroupProperties';
import { useTranslation } from 'react-i18next';
import { Title } from '../../../../store/api';
import { showNotification } from '../../../../shared/notification/toastNotification';
import { globalErrorResponse } from '../../../../shared/notification/actions';

export const useSaveLibraryManagedProductGroupProperties = (productGroupId: string) => {
    const { t } = useTranslation();

    return useMutation(
        (params: { titles: Title[]; sorting: string }) =>
            saveLibraryManagedProductGroupProperties({ ...params, productGroupId }),
        {
            onSuccess: () => {
                invalidateLibraryManagedProductGroupFeaturedPages().then();

                showNotification(t('marketing.productGroups.warnings.savePropertiesSuccessful'));
            },
            onError: () => {
                globalErrorResponse(t('marketing.productGroups.warnings.savePropertiesError'));
            }
        }
    );
};
